import { render, staticRenderFns } from "./MobileNotification.vue?vue&type=template&id=30bfb566&scoped=true&"
import script from "./MobileNotification.vue?vue&type=script&lang=js&"
export * from "./MobileNotification.vue?vue&type=script&lang=js&"
import style0 from "./MobileNotification.vue?vue&type=style&index=0&id=30bfb566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bfb566",
  null
  
)

export default component.exports